import React from 'react'
import { LoaderProps } from '../../types'
import '../../styles.scss'

const Loader: React.FC <LoaderProps> = ({ size, border }) => {
    return <div className = "loader" style = {{ width: size, height: size, borderWidth: border }} />
}

export default Loader